import {
  fetchGetMissionPlans,
  fetchPostMissionPlan,
  fetchDeleteMissionPlan,
  fetchDeleteMissionVersion,
  fetchDeployMissionPlan,
  fetchPatchMissionPlan,
} from "./actions";
import {
  getMissionPlanModalItemsDictSemanticMapId,
  getMissionVersions,
} from "./selectors";
import MissionsSlice from "./reducers";

// actions
export const {
  resetMissionPlans,
  addNewMissionPlan,
  updateMissionPlan,
  updateMissionDeploymentTime,
  removeMissionPlan,
  removeMissionVersion,
  setMissionVersions,
} = MissionsSlice.actions;

// async actions
export {
  fetchGetMissionPlans,
  fetchPostMissionPlan,
  fetchDeleteMissionPlan,
  fetchDeleteMissionVersion,
  fetchDeployMissionPlan,
  fetchPatchMissionPlan,
};

// selectors
export { getMissionPlanModalItemsDictSemanticMapId, getMissionVersions };

// reducer
export default MissionsSlice.reducer;
